














































import { Component, Vue } from 'vue-property-decorator';
import { ApiService } from '@/services/ApiService';
import {
  PageMetadataDto,
  UserNotificationDto,
  UserNotificationsResultDto,
  UserNotificationTypeDto
} from '@eurogast/hub-client-typescript';
import NotificationListItem from '@/notifications/NotificationListItem.vue';
import Pagination from '@/common/Pagination.vue';
import NotificationApiService from '@/services/notification/NotificationApiService';

@Component({
  components: { Pagination, NotificationListItem }
})
export default class NotificationCenter extends Vue {
  private pageInfo: PageMetadataDto = null;
  private notifications: UserNotificationDto[] = [];
  private allTypes: UserNotificationTypeDto[] = [];
  private selectedTypeId = -1;
  private currentPage = 0;
  private selectedNotificationIds: number[] = [];
  private unreadNotificationCount = 0;

  private notificationService = NotificationApiService.singleton();

  public async mounted() {
    this.unreadNotificationCount = await this.notificationService.fetchUnreadCount();

    const notificationResult = await this.fetchNotificationsWithoutTypeFilter();
    this.notifications = notificationResult.items;
    this.allTypes = notificationResult.allTypes;
    this.pageInfo = notificationResult.page;
  }

  get isTypeSelected(): boolean {
    return this.selectedTypeId !== -1;
  }

  get morePages(): boolean {
    return this.pageInfo && this.pageInfo.totalPages > 0;
  }

  get allUnreadSelected() {
    if (this.selectedNotificationIds.length > 0) {
      const unreadNotificationIds = this.notifications.filter((msg) => msg.unread).map((msg) => msg.id);
      if (unreadNotificationIds.length === this.selectedNotificationIds.length) {
        return unreadNotificationIds.every((id) => this.selectedNotificationIds.indexOf(id) !== -1);
      }
    }
    return false;
  }

  public toggleAllUnreadSelected() {
    if (this.allUnreadSelected) {
      this.selectedNotificationIds = [];
    } else {
      this.selectedNotificationIds = this.notifications.filter((msg) => msg.unread).map((msg) => msg.id);
    }
  }

  public isChecked(notificationId: number): boolean {
    return this.selectedNotificationIds.indexOf(notificationId) !== -1;
  }

  public async fetchCurrentPage() {
    try {
      const apiResult = await this.fetchNotifications();
      this.notifications = apiResult.items;
      this.pageInfo = apiResult.page;
    } catch (e) {
      await ApiService.defaultErrorHandler(e);
    }
  }

  private async fetchNotifications(): Promise<UserNotificationsResultDto> {
    if (this.isTypeSelected) {
      return this.fetchNotificationsWithTypeFilter();
    } else {
      return this.fetchNotificationsWithoutTypeFilter();
    }
  }

  private async fetchNotificationsWithoutTypeFilter(): Promise<UserNotificationsResultDto> {
    return this.notificationService.fetchUserNotifications(this.currentPage, 50, null);
  }

  private async fetchNotificationsWithTypeFilter(): Promise<UserNotificationsResultDto> {
    return this.notificationService.fetchUserNotifications(this.currentPage, 50, this.selectedTypeId);
  }

  public fetchFirstPage() {
    this.currentPage = 0;
    this.fetchCurrentPage();
  }

  public toggleChecked(notificationId) {
    const notificationIdIndex = this.selectedNotificationIds.indexOf(notificationId);
    if (notificationIdIndex === -1) {
      this.selectedNotificationIds.push(notificationId);
    } else {
      this.selectedNotificationIds.splice(notificationIdIndex, 1);
    }
  }

  public onPageChanged(newPage: number) {
    this.currentPage = newPage;
    this.fetchCurrentPage();
  }

  public async markAsRead(notificationIds: number[]) {
    try {
      await this.notificationService.markAsReadBatch(notificationIds);
      await this.fetchCurrentPage();
      this.unreadNotificationCount = await this.notificationService.fetchUnreadCount();
      this.removeFromSelectedNotifications(notificationIds);
    } catch (e) {
      await ApiService.defaultErrorHandler(e);
    }
  }

  private removeFromSelectedNotifications(notificationIds: number[]) {
    notificationIds.forEach((id) => {
      const index = this.selectedNotificationIds.indexOf(id);
      if (index !== -1) {
        this.selectedNotificationIds.splice(index, 1);
      }
    });
  }
}
